import { render, staticRenderFns } from "./UserRights.vue?vue&type=template&id=d8a7d1e4&scoped=true"
import script from "./UserRights.vue?vue&type=script&lang=js"
export * from "./UserRights.vue?vue&type=script&lang=js"
import style0 from "./UserRights.vue?vue&type=style&index=0&id=d8a7d1e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a7d1e4",
  null
  
)

export default component.exports